export const CARD_WIDTHS = {
	default: {
		small: {
			largeScreen: 170, // For screens >= 1600px
			smallScreen: 136, // For screens < 1600px
		},
		large: {
			largeScreen: 350, // For screens >= 1600px
			smallScreen: 282, // For screens < 1600px
		},
	},
	chokwin: {
		small: {
			largeScreen: 140,
			smallScreen: 140,
		},
		large: {
			largeScreen: 290,
			smallScreen: 290,
		},
	},
};

export const getCardWidth = (size, windowWidth, tenantName = "default") => {
	const isLargeScreen = windowWidth >= 1600;
	const isSmallCard = size === "1x2" || size === "1x1";

	const config = CARD_WIDTHS[tenantName] || CARD_WIDTHS.default;

	if (isSmallCard) {
		return isLargeScreen ? config.small.largeScreen : config.small.smallScreen;
	} else {
		return isLargeScreen ? config.large.largeScreen : config.large.smallScreen;
	}
};
